<template>
  <div class="contant-wrap">
    <div class="header">
      <h4 class="common-title">库存管理</h4>
      <!-- <div class="info-show">
        <i class="el-icon-info"></i><span>库存价值：￥{{totalInventPrice}}</span>
        &nbsp;
        <i class="el-icon-info"></i><span>零售预期 ：￥{{totalSellPrice}}</span>
      </div> -->
    </div>
    <!-- filterData  -->
    <div class="filter-data">
      <div class="filter-control">
        <div class="row">
          <el-row :gutter="40">
						<el-col :span="8">
              <div class="fix-wrap">
                 <label for="">药品分类：</label>
                  <el-select v-model="query.drugType" @change="paramsChange" placeholder="请选择" class="container">
                    <el-option
                      v-for="item in drugTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </div>
						</el-col>
            <el-col :span="8">
              <div class="fix-wrap">
                <his-autocomplete-suggestions
                  :fetch-suggestions="querySearch"
                  pointKey="drugName"
                  showSearch
                  @searchHandle="searchHandle"
                  @selectHandle="selectHandle"
                  placeholder="药品名"
                  :isShopDrugs="isShopDrugs === 1"
                  class="container">
                    <template slot-scope="slotProps">
                      <div class="search-item">
                        <div> 
                          <img src="../../../assets/images/logo-l.png" class="logo-img"  v-if="slotProps.item.isShopDrugs === 1"/>
                          {{slotProps.item.drugName}}
                        </div>
                        <div> {{slotProps.item.specification}} </div>
                        <div> {{slotProps.item.manufacturer}} </div>
                      </div>
                    </template>
                  </his-autocomplete-suggestions>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="fix-wrap">
                 <el-switch
                  v-model="query.allInstock"
                  @change="paramsChange"
                  active-text="含空库存"
                  inactive-text="">
                </el-switch>
                <!-- <el-button type="primary" class="button">查询</el-button> -->
                <el-button type="success" class="button" @click="fileExport">导出</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="table">
      <el-table
        :data="tableData"
        :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}"
        style="width: 100%">
        <el-table-column
          prop="drugName"
          label="药品名称"
          width="180">
          <template slot-scope="scope">
            <img src="../../../assets/images/logo-l.png" class="logo-img"  v-if="scope.row.isShopDrugs === 1"/>
            {{scope.row.drugName}}
          </template>
        </el-table-column>
        <el-table-column
          prop="customType"
          align="center"
          label="药品分类"
          width="180">
          <template slot-scope="scope">
              {{scope.row.drugType | getTypeStr}}
          </template>
        </el-table-column>
        <el-table-column
          prop="specification"
          align="center"
          label="规格">
        </el-table-column>
        <el-table-column
          prop="manufacturer"
          align="center"
          label="厂家">
        </el-table-column>
        <el-table-column
          prop="sellInfo"
          align="center"
          sortable
          label="零售价">
        </el-table-column>
        <el-table-column
          prop="shelfCode"
          align="center"
          sortable
          label="货架码">
        </el-table-column>
        <el-table-column
          prop="inventoryCount"
          align="center"
          label="总库存">
          <template slot-scope="scope">
              {{scope.row.inventoryInfo}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="toFlow(scope.row)">查看流向</el-button>
            <el-button type="text" @click="showDetail(scope.row)">批号详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="tableData.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="query.currentPage"
          :page-size.sync="query.pageSize"
          :page-sizes="pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPages">
        </el-pagination>
      </div>
    </div>
    <!-- dialog -->
    <el-dialog :title="tableTitle" :visible.sync="dialogTableVisible">
      <el-table :data="batchList" max-height="400">
        <el-table-column property="drugBatchNo" align="left" label="批号" width="150"></el-table-column>
        <el-table-column property="specification" align="center" label="规格" width="200"></el-table-column>
        <el-table-column property="validityDate" align="center" label="有效期"></el-table-column>
        <el-table-column property="purchasePrice" align="center" label="进货价(￥)">
          <template slot-scope="scope">
            {{scope.row.purchasePrice}}元/{{scope.row.instockUnit}}
          </template>
        </el-table-column>
        <el-table-column property="stock" align="center" label="当前数量"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { drugType, pageSizes } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import setUrl from '@/mixins/setUrl';

export default {
  name: '',
  components: { HisAutocompleteSuggestions },
  mixins: [ pageSize, setUrl ],
  data() {
    return {
      tableTitle: '批号详情',
      pageSizes,
      dialogTableVisible: false,
      tableData: [],
      radio: false,
      value: '',
      options: [],
      input5: '',
      drugTypeList: drugType,
      totalInventPrice: 0,
      totalSellPrice: 0,
      query: {
        drugType: -1,
        drugName: '',
        allInstock: false,
        currentPage: 1,
        pageSize: 20,
      },
      totalPages: 0,
      batchList: [],
      isShopDrugs: 0,
    };
  },
  methods: {
    showDetail(item) {
      this.$api.drugControl.batchInstockId({id: item.id}).then((res) => {
        this.batchList = res;
      })
      this.tableTitle = `"${item.drugName}"批号详情`;
      this.dialogTableVisible = true;
    },
    toFlow(item) {
      this.$router.push({name: 'flowQuery', query: {drugId: item.id}})
    },
    getList(type) {
      if (type === 1) {
        this.query.currentPage = 1;
      }
      this.queryChangeHandle();
      this.$api.drugControl.inventoryManage({
        ...this.query, 
        allInstock: this.query.allInstock ? 1 : 0,
      }).then((res) => {
        this.tableData = res.drugList;
        this.totalSellPrice	= res.totalSellPrice;
        this.totalInventPrice	= res.totalInventPrice;
        this.totalPages = res.totalSize;
      });
    },
    paramsChange() {
      this.getList(1);
    },
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getList(1);
    },
    handleCurrentChange(e) {
      this.query.currentPage = e;
      this.getList();
    },
    fileExport() {
      this.$api.drugControl.inventoryManageExport({
        drugType: this.query.drugType,
        drugName: this.query.drugName,
        allInstock: this.query.allInstock ? 1 : 0,
      });
    },
    querySearch(str, cb) {
      this.isShopDrugs = 0;
      this.$api.drugControl.getDrugByName({ drugName: str }).then(res => {
        if(Array.isArray(res) && res.length > 0) {
          cb(res)
        } else {
          cb([]);
        };
      });
    },
    searchHandle(e) {
      this.query.drugName = e;
      this.getList(1);
    },
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.isShopDrugs = e.isShopDrugs;
      this.getList(1);
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        drugType: this.query.drugType,
        currentPage: this.query.currentPage,
        allInstock: this.query.allInstock,
        drugName: this.query.drugName,
      })
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.query.drugName = queryUrl.drugName ? queryUrl.drugName : '';
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
      if (queryUrl.drugType) {
        this.query.drugType = Number(queryUrl.drugType);
      }
      if (queryUrl.hasOwnProperty('allInstock')) {
        this.query.allInstock = Boolean(queryUrl.allInstock);
      }
    },
  },
  filters: {
    getTypeStr(val) {
      const item = drugType.find(res => res.value == val);
      if (item) {
        return item.label;
      }
      return '';
    },
  },
  mounted() {
    this.initQuery();
    this.getList();
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  span {
    color: #999999;
    margin-left: 10px;
  }
  .el-icon-info {
    color: #88BEFD;
  }
  span {
    color: #999999;
  }
}

.button {
  margin-left: 30px;
}
</style>
